import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';
import ValidationFail from '~/composer/composer/lib/validation/ValidationFail';
import ValidationSuccess from '~/composer/composer/lib/validation/ValidationSuccess';
import { EditorStateProxy } from '~/composer/composer/entities/EditorStateProxy';
import twitterText from 'twitter-text';
import ValidationResult from '~/composer/composer/lib/validation/ValidationResult';
import {
  getMaxCharactersForTitleMessage,
  PINTEREST_INVALID_DESTINATION_LINK,
  PINTEREST_SHORTENED_LINK,
} from './utils/validationErrorMessages';

export default class PinterestValidator extends BaseValidator {
  protected isValidSourceUrl() {
    const isSourceUrlUnrequiredOrValid =
      !this.draft.service.canHaveSourceUrl ||
      this.draft.sourceLink === null ||
      twitterText.isValidUrl(this.draft.sourceLink.url, true, false);
    if (!isSourceUrlUnrequiredOrValid) {
      return new ValidationFail(PINTEREST_INVALID_DESTINATION_LINK);
    }
    return new ValidationSuccess();
  }

  protected linkWithoutShortener() {
    const isPinterest = this.draft.service.name === 'pinterest';
    const isPinterestSourceUrlUsingLinkShortener =
      isPinterest &&
      (this.draft.sourceLink?.url?.includes('bit.ly/') ||
        this.draft.sourceLink?.url?.includes('buff.ly/') ||
        this.draft.sourceLink?.url?.includes('j.mp/'));

    const contentText = EditorStateProxy.getPlainText(this.draft.editorState);
    const linksInText = twitterText.extractUrls(contentText);

    const hasPinterestLinkWithoutSourceUrl =
      isPinterest && linksInText.length > 0 && !this.draft.sourceLink;
    if (
      hasPinterestLinkWithoutSourceUrl ||
      isPinterestSourceUrlUsingLinkShortener
    ) {
      return new ValidationFail(PINTEREST_SHORTENED_LINK);
    }
    return new ValidationSuccess();
  }

  protected maxCharactersInTitle() {
    if (
      this.draft.service.titleCharLimit !== null &&
      (this.draft.characterTitleCount ?? 0) > this.draft.service.titleCharLimit
    ) {
      return new ValidationFail(
        getMaxCharactersForTitleMessage(this.draft.service.titleCharLimit)
      );
    }
    return new ValidationSuccess();
  }

  protected validateForChannel(): ValidationResult[] {
    return [
      this.linkWithoutShortener(),
      this.isValidSourceUrl(),
      this.maxCharactersInTitle(),
    ];
  }
}
